import React, { useState } from "react"
import { graphql } from "gatsby"
import ArrowLeft from "icons/arrow_left.svg"
import ArrowRight from "icons/arrow_right.svg"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination, Keyboard } from "swiper"

export const query = graphql`
  fragment ImageCarouselFields on DatoCmsImageCarousel {
    id
    model {
      apiKey
    }
    componentId: key
    showDownloadIcon
    headline
    slides {
      id
      labelNode {
        childMarkdownRemark {
          html
        }
      }
      image {
        alt
        height
        width
        portraitUrl: url(imgixParams: { ar: "2:3", h: "750", fit: "crop" })
        landscapeUrl: url(
          imgixParams: { ar: "16:9", h: "750", w: "1250", fit: "crop" }
        )
        urlJpgImage: url(imgixParams: { fm: "jpg" })
      }
    }
  }
`

const ImageCarousel = (props: Queries.ImageCarouselFieldsFragment) => {
  const [prevEl, setPrevEl] = useState<HTMLElement | null>(null)
  const [nextEl, setNextEl] = useState<HTMLElement | null>(null)
  const [paginationbarEl, setPaginationbarEl] = useState<HTMLElement | null>(
    null,
  )
  const slides = props.slides || []
  const headline = props.headline

  return (
    <section id={props.componentId} className="c-image-carousel o-row">
      {headline && <h2 className="c-content-header">{headline}</h2>}
      <Swiper
        modules={[Navigation, Pagination, Keyboard]}
        className="c-image-carousel__carousel-container"
        slidesPerView={"auto"}
        spaceBetween={20}
        breakpoints={{
          768: {
            spaceBetween: 30,
          },
        }}
        centeredSlides={true}
        navigation={{ prevEl, nextEl }}
        speed={700}
        slideToClickedSlide={true}
        onActiveIndexChange={swiper => {
          if (paginationbarEl) {
            paginationbarEl.style.left =
              swiper.realIndex * 45 + swiper.realIndex * 10 + "px"
          }
        }}
        pagination={{
          clickable: true,
          el: ".c-image-carousel__dot-group",
          bulletElement: "button",
          bulletClass: "dot",
          bulletActiveClass: "c-image-carousel__dot--selected",
        }}
        keyboard={{
          enabled: true,
          onlyInViewport: true,
        }}
      >
        {slides.map(slide => (
          <SwiperSlide
            key={slide.id}
            className="c-image-carousel__slide c-horizontal-teaser"
          >
            <div className="c-image-carousel__image">
              <img
                data-islandscape={slide.image.width > slide?.image?.height}
                src={
                  slide?.image.height > slide?.image.width
                    ? slide?.image?.portraitUrl
                    : slide?.image.landscapeUrl
                }
                alt={slide.image.alt}
              />
              {props.showDownloadIcon && (
                <span
                  className="c-image-carousel__image__download"
                  title="Open image in new tab"
                  onClick={() => {
                    window.open(slide.image.urlJpgImage)
                  }}
                />
              )}
            </div>
            <div className="c-image-carousel__content">
              {slide.labelNode && slide.labelNode.childMarkdownRemark && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: slide.labelNode.childMarkdownRemark.html,
                  }}
                />
              )}
            </div>
          </SwiperSlide>
        ))}

        <div className="c-image-carousel__dots-outer">
          <div className="c-image-carousel__dots-inner">
            <div className="c-image-carousel__dot-group"></div>
            <span
              className="c-image-carousel__dot-group__bar"
              ref={node => setPaginationbarEl(node)}
            ></span>
          </div>
        </div>

        <div className="c-image-carousel__navigation-container">
          <button
            ref={node => setPrevEl(node)}
            className="c-image-carousel__previous"
          >
            <ArrowLeft />
          </button>
          <button
            ref={node => setNextEl(node)}
            className="c-image-carousel__next"
          >
            <ArrowRight />
          </button>
        </div>
      </Swiper>
    </section>
  )
}

export default ImageCarousel
